export default "__VITE_ASSET__DuAtyV3R__"